import { createAxios, createAxiosLogistica } from "./axiosHttpMarconi";
export const serviciosService = {
  getServicios,
  getServiciosByCliente,
  getServiciosLogisticaByCliente,
};

function getServicios(tipoServicio) {
  const axios = createAxios();
  //const tipo = localStorage.getItem('tipo');
  let urlPath = `/servicio?sort=_id&order=ascending`;
  if (tipoServicio && tipoServicio != "") {
    urlPath += `&tipo=${tipoServicio}`;
  }
  return axios.get(urlPath);
}

function getServiciosByCliente(request) {
  const axios = createAxios();
  //const tipo = localStorage.getItem('tipo');
  let urlPath = `/servicio/cliente/${request.id}?no_usar_confi_servicios=True`;
  if (request.tipo && request.tipo != "") {
    urlPath += `&tipo=${request.tipo}`;
  }
  if (request.rma && request.rma != "") {
    urlPath += `&rma=${request.rma}`;
  }
  if (request.palet && request.palet != "") {
    urlPath += `&palet=${request.palet}`;
  }
  return axios.get(urlPath);
}

function getServiciosLogisticaByCliente(clienteId) {
  const axios = createAxiosLogistica();
  return axios.get(`/logistica/cliente/${clienteId}/servicios`);
}
